import { render, staticRenderFns } from "./vip-msg-integral.vue?vue&type=template&id=5b56265d&scoped=true&"
import script from "./vip-msg-integral.vue?vue&type=script&lang=js&"
export * from "./vip-msg-integral.vue?vue&type=script&lang=js&"
import style0 from "./vip-msg-integral.vue?vue&type=style&index=0&id=5b56265d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b56265d",
  null
  
)

export default component.exports